<template>
    <BaseSection
        v-if="richText"
        width="page-narrow"
    >
        <RichText :text="richText || undefined" />
    </BaseSection>
</template>

<script setup>
import RichText from '~/components/RichText/RichText.vue';
defineProps({
    richText: {
        type: String,
        required: true,
        default: null
    }
});
</script>

